import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { REPORTS_TABS } from "./utils";

const Reports = () => {
  const [selectedTab, setSelectedTab] = useState(REPORTS_TABS[0].tabTitle);

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (tabName: string) => {
    setSelectedTab(tabName);
    // change the url param as well
    navigate(`/control-center/reports/${tabName}`);
  };

  useEffect(() => {
    // get the tab name from the url param
    const tabName = location.pathname.split("/").pop();
    if (tabName) {
      setSelectedTab(tabName);
    }
  }, [location.pathname]);

  return (
    <div className="users-permissions-management-page">
      <Tabs
        id="controlled-tab-example"
        activeKey={selectedTab}
        onSelect={handleTabChange}
        className="mb-3 tabs-container"
      >
        {REPORTS_TABS.map(({ tabTitle, tabComponent }, index) => {
          const SelectedTab = tabComponent;

          return (
            <Tab eventKey={index} title={tabTitle} key={tabTitle}>
              <SelectedTab />
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default Reports;
